import { BaseDto } from "@/shared/dtos/base-dto";

export class Usuario extends BaseDto {
  public email!: string;
  public contra!: string;
  public nombre!: string;
  public cambiar_pwd_entrar!: boolean;
  public id_rol!: number;
  public descripcion!: string;
  public nif!: string;
  public id_centro!: number | null;
  public num_seg_social!: string;
  public ids_datos_empresa: number[] = [];
}
